import React from "react";

export default function CreateVehicleFuel() {
  return (
    <div className="createvehiclefuel-container my-4">
      <div className="col-md-12">
        <div className="special-header panel-white-all">
          <h4 className="page-title">Create Vehicle Fuel</h4>
        </div>

        <form>
          <div className="row create-vehicle-row">
            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="vehicleno" className="form-label"> Vehicle Number <span className="text-danger">*</span></label>
              <select id="vehicleno" className="form-control createfuel-form-select" >
                <option>Select</option>
                <option>MH21WE9021</option>
                <option>MH02WE0002</option>
                <option>MH03BR8934</option>
              </select>
            </div>
            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="odometer" className="form-label"> Current Odometer <span className="text-danger">*</span> </label>
              <input type="text" id="odometer" className="form-control createfuel-form-control" placeholder="Enter odometer reading" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="quantity" className="form-label"> Quantity <span className="text-danger">*</span>  </label>
              <input type="text" id="quantity" className="form-control createfuel-form-control" placeholder="Enter fuel quantity" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="amount" className="form-label"> Amount <span className="text-danger">*</span> </label>
              <input type="text" id="amount" className="form-control createfuel-form-control" placeholder="Enter amount" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3">
              <label htmlFor="date" className="form-label"> Date <span className="text-danger">*</span></label>
              <input  type="date"  id="date"  className="form-control createfuel-form-control" />
            </div>

            <div className="col-lg-6 col-md-12 mb-3 d-flex align-items-end justify-content-end">
              <button type="submit" className="btn custom-btn">
                Create
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
